import { FC, useEffect, useState } from 'react';
import EditorIcon from 'lowcode/components/EditorIcon';
import EditorLink from 'lowcode/components/EditorLink';
import EditorEmarsysEmail from 'lowcode/components/EditorEmarsysEmail';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import { useRouter } from 'next/router';
import EditorTooltip from 'lowcode/components/EditorTooltip';
import EFPicture from '@elem/compCommon/EFPicture';
import IconMark from '../../components/icons/IconMark';
import css from './index.module.scss';
import IconA from './IconA';
import IconB from './IconB';
import IconC from './IconC';
import IconArr from './IconArr';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import { signupCookie } from '@/utils/cookies/signupCookie';

const TheComp: FC = () => {
    const { Link } = useGlobal();
    const { t } = useLang('dp3.teaser.SubscribeA');
    const { pathname, locale } = useRouter();
    const [hrefR, setHrefR] = useState(`/${locale}/register?redirect=/${locale}${pathname}`);

    useEffect(() => {
        const isLogin2 = getIsLogin();
        if (isLogin2) {
            setHrefR(`/${locale}/ecocredits`);
        }
    }, []);

    // 弹窗
    const [visibleWin, setVisibleWin] = useState('');
    // 打开弹窗
    const openWinHandle = (type: string) => {
        setVisibleWin(type);
    };
    // 关闭弹窗
    const closeWinHandle = () => {
        setVisibleWin('');
    };

    return (
        <div className={`${css.thecomp}`} id="dp3-SubscribeA">
            <div className="dp3-spec"></div>
            <h2 className="dp3-title">{t('title')}</h2>
            <div className="comp-in">
                <div className="comp-list">
                    <div className="comp-item">
                        <div className="comp-item-title">{t('item1_title')}</div>
                        <div className="comp-item-icon">
                            <IconA />
                        </div>
                        <div className="comp-item-desc">{t('item1_desc')}</div>
                    </div>
                    <div className="comp-item-arrow">
                        <IconArr />
                    </div>
                    <div className="comp-item">
                        <div className="comp-item-title">{t('item2_title')}</div>
                        <div className="comp-item-icon">
                            <IconB />
                        </div>
                        <div className="comp-item-desc">{t('item2_desc')}</div>
                    </div>
                    <div className="comp-item-arrow">
                        <IconArr />
                    </div>
                    <div className="comp-item">
                        <div className="comp-item-title">{t('item3_title')}</div>
                        <div className="comp-item-icon">
                            <IconC />
                        </div>
                        <div className="comp-item-desc">{t('item3_desc')}</div>
                    </div>
                </div>
                <div className="comp-box">
                    <div className="comp-box-side comp-box-r">
                        <div className="part1">
                            <div className="comp-box-icon">
                                <EditorIcon pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349617546/Coupon.png" />
                            </div>
                            <div className="comp-box-info">
                                <div className="comp-box-title">
                                    {t.rich('box_title1', {
                                        s: (tx: string) => <span className="small-desc">{tx}</span>,
                                    })}
                                </div>
                                <div className="comp-box-btns">
                                    <EditorEmarsysEmail
                                        contactListId="180562521"
                                        fields={[
                                            // SMS
                                            {
                                                id: '9157',
                                                type: 'multiple',
                                                value: [2],
                                                overwrite: true,
                                            },
                                            {
                                                id: '31',
                                                type: 'single',
                                                value: 1,
                                                overwrite: true,
                                            },
                                            {
                                                id: '4431',
                                                type: 'single',
                                                value: 1,
                                                overwrite: true,
                                            },
                                        ]}
                                        tipsObj={{
                                            placeholder: t('box_placeholder'),
                                            btnText: t('box_btn1'),
                                            successTips: t('box_input_success'),
                                            tipsEmpty: t('box_input_error'),
                                            tipsTypeError: t('box_input_error'),
                                        }}
                                        callback={(value: string) => {
                                            if (locale === 'jp') {
                                                return gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'activity_submit',
                                                    button_name: t('box_btn1'),
                                                    status: value,
                                                    tag: 'Agree',
                                                });
                                            }
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_button',
                                                page_name: 'delta-pro-3-portable-power-station',
                                                list_name: t('box_title1'),
                                                button_name: t('box_btn1'),
                                                function: 'Subscription',
                                            });
                                        }}
                                        needTerms={true}
                                        a1={'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html'}
                                        a2={'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html'}
                                        langKey="dp3.teaser.SubscribeA"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="line"></div>
                        <div className="part2">
                            <p className="part2-title">{t('box_line_title')}</p>
                            <p className="part2-desc">{t('box_line_desc')}</p>
                            <div className="pics">
                                <Link
                                    className="line-picture"
                                    href="https://lin.ee/CC63mEL"
                                    target="_blank"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'line_icon_click',
                                        button_name: 'Line',
                                        url: 'https://lin.ee/CC63mEL',
                                    }}
                                >
                                    <EFPicture
                                        src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718353443169/LINE_Brand_icon%201.png"
                                        alt={t('box_line_title')}
                                    />
                                </Link>
                                <div className="line-picture">
                                    <EFPicture
                                        src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718353640989/M_gainfriends_2dbarcodes_GW%201.png"
                                        alt={t('box_line_title')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="comp-box-side comp-box-l">
                        <div className="comp-box-icon">
                            <EditorIcon pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718353783493/EcoCredits.png" />
                        </div>
                        <div className="comp-box-info">
                            <div className="comp-box-title">{t('box_title2')}</div>
                            <div className="comp-box-btns">
                                <EditorLink
                                    href={hrefR}
                                    className="comp-box-btn"
                                    onClick={
                                        getIsLogin()
                                            ? undefined
                                            : () => {
                                                  signupCookie({
                                                      sector_name: t('title'),
                                                      entry_position: 8,
                                                  });
                                              }
                                    }
                                    dataLayer={
                                        getIsLogin()
                                            ? {
                                                  event: 'uaEvent',
                                                  event_name: 'activity_preview',
                                                  button_name: t('box_btn2'),
                                              }
                                            : {
                                                  event: 'uaEvent',
                                                  event_name: 'activity_button',
                                                  page_name: 'delta-pro-3-portable-power-station',
                                                  list_name: t('box_title2'),
                                                  button_name: t('box_btn2'),
                                                  function: 'Join in',
                                              }
                                    }
                                >
                                    {t('box_btn2')}
                                </EditorLink>
                            </div>
                        </div>
                        <span
                            className="comp-box-icon-mark"
                            onClick={() => {
                                openWinHandle('win2');
                            }}
                        >
                            <IconMark />
                            <EditorTooltip>{t('box_tips1')}</EditorTooltip>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TheComp;
